module.exports = __webpack_public_path__ + "static/img/btn_tijiao_nor.fae8389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_tijiao_nor.png
// module id = fhUS
// module chunks = 1